<template>
  <v-flex md6
          offset-md3>
    <form v-on:submit.prevent="validate"
          class="spacing-top"
          md-6
          offset-3>

      <div class="sign-avatar">
        <router-link to="/">
          <img src="/static/img/logo.png"
               alt=""
               class="img-circle"></router-link>
      </div>
      <div class="form-group">
        <api-select></api-select>
      </div>
      <v-text-field :label="$t('login_email_placeholder')"
                    v-model="username"
                    name="username"
                    type="email"
                    required
                    v-validate="{required: true, email: true}">
        <small class="text-danger">
          {{ errors.first('email') }}
        </small>
      </v-text-field>

      <v-text-field :label="$t('login_password_placeholder')"
                    v-model="passwordForm"
                    type="password"
                    name="password"
                    required
                    v-validate="{required: true}">
        <small class="text-danger">
          {{ errors.first('password') }}
        </small>
      </v-text-field>

      <v-container fluid>
        <v-layout v-bind="binding"
                  align-center>
          <v-flex xs12
                  sm5
                  order-sm2
                  order-xs2
                  :class="{'text-xs-left': $vuetify.breakpoint.mdAndUp, 'ma-2': $vuetify.breakpoint.smAndDown}">
            <router-link to="/forgot-password"
                         v-html="$t('reset_title')"></router-link>
          </v-flex>

          <v-flex xs12
                  sm10
                  order-md2
                  :class="{'text-xs-right': $vuetify.breakpoint.mdAndUp}">

            <v-btn href="/"
                   round
                   class="capitalize"
                   color="grey lighten-3">
              {{$t('login_button_back')}}
            </v-btn>
            <v-btn :loading="isLoading"
                   round
                   color="primary"
                   type="submit"
                   class="capitalize"
                   :disabled="isLoading">
              {{ $t('login_button_send') }}
              <span slot="loader"
                    class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
  </v-flex>
</template>

<script>
import ApiSelect from './ApiSelect';
import { mapFields } from 'vee-validate';
import authService from '@/services/authService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  computed: {
    ...mapFields(['email', 'password']),
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = false;
      else {
        binding.column = true;
      }

      return binding;
    }
  },
  components: {
    [ApiSelect.name]: ApiSelect
  },
  data() {
    return {
      passwordForm: '',
      username: '',
      isLoading: false
    };
  },
  methods: {
    validate() {
      this.$validator.validateAll().then(async res => {
        if (res) {
          var params = {
            username: this.username,
            password: this.passwordForm
          };
          this.isLoading = true;
          await authService.login(params, this.loginSuccessHandler, this.loginErrorHandler);
        }
      });
    },
    loginSuccessHandler(data) {
      this.isLoading = false;
      this.$router.push({ name: 'Dashboard' });
    },
    loginErrorHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: this.$i18n.t('error_401_login_title'),
        message: this.$i18n.t('error_401_login_message'),
        type: 'error',
        doNotTranslate: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/Login.vue